export enum EEmitentJe {
    UI = 'UI',
    UO = 'UO',
    EM = 'EM',
    FO = 'FO',
    NA = 'NA'
}
